// extracted by css-extract-rspack-plugin
export default {"scrollContainer":"jHwBBDNXeLQnPvoK","spacer":"ZwW1CjEF7M4YfxM4","row":"dGliqdUu0M9_kGvi"};